import { useState } from 'react'
import { useParams } from 'react-router-dom'

import {
  IsFormsAbstractionEnabledDocument,
  TrainingFormWithTrainingDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import FormEditor from 'modules/forms/components/FormEditor'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Form } from 'modules/trainings/components/Revamp/Form'

const TrainingFormDetail = () => {
  const { id, formId } = useParams<{ id: string; formId: string }>()
  const { company } = useCurrentSession()
  const { data, loading, error } = useQuery(TrainingFormWithTrainingDocument, {
    variables: { id: formId ?? '', trainingId: Number(id) },
  })

  const trainingForm = data?.forms.form ?? undefined

  const [openSidepanel, setOpenSidepanel] = useState<boolean>(false)
  const { data: featuresData } = useQuery(IsFormsAbstractionEnabledDocument, {
    variables: { companyId: company.id },
  })
  const hasFormsFF = featuresData?.features.featuresConnection.nodes[0]?.enabled ?? false

  return (
    <ResponsivePage.Body
      showHeader={false}
      loading={loading}
      error={error}
      variant="fullscreen"
      height="full"
    >
      {hasFormsFF ? (
        <FormEditor
          formId={String(formId)}
          resourceId={String(id)}
          resourceType={'Trainings::Training'}
        />
      ) : (
        <Form
          openSidepanel={openSidepanel}
          setOpenSidepanel={setOpenSidepanel}
          trainingForm={trainingForm}
          trainingId={Number(id)}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default TrainingFormDetail
